import { ReactComponent as ChevronLeftIcon } from '../../common/icons/chevronLeft.svg';

interface DiscountLinkProps {
  label: string;
  onClick: () => void;
}

export function DiscountLink({ label, onClick }: DiscountLinkProps) {
  return (
    <button
      data-cy="discount-link"
      className="GiftBox-Discount-Link fixed bg-white bottom-0 left-0 pt-3 px-5 pb-[34px] flex justify-between items-center w-full hover:cursor-pointer [&>svg]:text-gray-600  [&>svg]:hover:text-gray-800  [&>svg]:active:text-gray-900"
      onClick={onClick}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          onClick();
        }
      }}
      style={{
        boxShadow:
          '0px 0px 40px 0px rgba(40, 42, 44, 0.08), 0px 0px 20px 0px rgba(40, 42, 44, 0.12)',
      }}
    >
      <span className="GiftBox-Discount-Link-Label text-heading-md">
        {label}
      </span>
      <ChevronLeftIcon className="rotate-180" />
    </button>
  );
}
